export const mapOptions = {
  draggable: false,
  zoomControl: true,
  scaleControl: false,
  disableDefaultUI: true,
  disableDoubleClickZoom: true,
  keyboardShortcuts: false,
  streetViewControl: false,
  scrollwheel : false,
  mapTypeControl: false,
  signInControl: false
};
